<template>
  <div class="map-editor-help">
    <div v-if="editorHelpShow" class="map-editor-help__container">
      <div class="map-editor-help__subcontainer">
        <template v-if="editorState.geom_type === 'line_routes'">
          <div class="map-editor-help__subtitle">
            Создание маршрута
          </div>
          <div class="map-editor-help__rows">
            <div class="map-editor-help__block">
              <b>ЛКМ</b> - поставить точку по предложенному маршруту
            </div>
            <div class="map-editor-help__block">
              <b>ДЛКМ</b> - закончить создание маршрута (поставить последнюю
              точку)
            </div>
            <div class="map-editor-help__block">
              <b>Ctrl + Z</b> - удаление последней точки
            </div>
            <div class="map-editor-help__block">
              <b>Escape</b> - отмена создания маршрута
            </div>
          </div>
        </template>
        <template v-else>
          <div class="map-editor-help__subtitle">
            Создание
          </div>
          <div class="map-editor-help__rows">
            <div class="map-editor-help__block">
              <b>ЛКМ</b> - создание объектов / вершин
            </div>
            <div class="map-editor-help__block">
              <b>ДЛКМ</b> - закончить создание геометрии (поставить последнюю
              вершину)
            </div>
            <div class="map-editor-help__block">
              <b>Escape</b> - отмена создания объекта
            </div>
          </div>
        </template>
      </div>
      <div class="map-editor-help__subcontainer">
        <template v-if="editorState.geom_type === 'line_routes'">
          <div class="map-editor-help__subtitle">
            Редактирование маршрута
          </div>
          <div class="map-editor-help__rows">
            <div class="map-editor-help__block">
              <b>ЛКМ</b> - выбор объекта / точки маршрута
            </div>
            <div class="map-editor-help__block">
              <b>Перетаскивание точек</b> - редактирование маршрута (новое
              расположение точки должно быть в узле или остановке, маршрут
              должен начинаться и заканчиваться в остановках)
            </div>
            <div class="map-editor-help__block">
              <b>Backspace</b> - удаление маршрута
            </div>
          </div>
        </template>
        <template v-else>
          <div class="map-editor-help__subtitle">
            Редактирование
          </div>
          <div class="map-editor-help__rows">
            <div class="map-editor-help__block">
              <b>ЛКМ</b> - выбор объекта / вершины
            </div>
            <div class="map-editor-help__block">
              <b>Shift + ЛКМ</b> - выбор нескольких объектов
            </div>
            <div class="map-editor-help__block">
              <b>Перетаскивание вершин / объекта</b> - редактирование геометрии
            </div>
            <div class="map-editor-help__block">
              <b>Backspace</b> - удаление объекта
            </div>
          </div>
        </template>
      </div>
    </div>
    <div
      @click="editorHelpShow = !editorHelpShow"
      class="map-editor-help__title"
    >
      <i
        :class="editorHelpShow ? 'el-icon-caret-top' : 'el-icon-caret-right'"
      ></i>
      Помощь
    </div>
  </div>
</template>

<script>
export default {
  props: ["editor-state"],
  data() {
    return {
      editorHelpShow: true
    };
  }
};
</script>

<style lang="scss">
.map-editor-help {
  margin-top: auto;
  color: var(--text_secondary) !important;

  &__title {
    font-size: 12px;
    cursor: pointer;
    margin: 8px;
    margin-top: 4px;
  }
  &__subtitle {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 5px;
    padding: 4px;
    padding-left: 10px;
    border-radius: var(--border-radius);
    text-transform: uppercase;
    color: var(--text_primary) !important;

    i {
      margin-right: 2px;
    }
  }
  &__subcontainer {
    &:not(:first-child) {
      margin-top: 10px;
    }
  }
  &__block {
    &:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      margin-left: 5px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: var(--bg_containers) !important;
    }
    &:not(:first-child) {
      margin-top: 4px;
    }
  }
  &__container {
    font-size: 12px;
    padding: 8px;
    margin-bottom: 8px;
    border-top: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
    background-color: var(--bg_panel_primary) !important;
  }

  &__rows {
    padding: 8px;
    padding-top: 0;
  }
}
</style>
